module.exports = __webpack_public_path__ + "images/section-bg-51-small.webp";